var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMissingAppIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M23.46 21.2l.05.04 17.8 21a.4.4 0 01-.57.57l-.05-.05-1.74-2.06H24.8a2.86 2.86 0 01-2.8-2.76V26.03c0-1.37.9-2.52 2.1-2.84l-1.2-1.43a.4.4 0 01.56-.57zm15.74 1.9c1.55 0 2.8 1.31 2.8 2.93v11.74c0 1.05-.53 1.98-1.33 2.5l-.54-.65a2.11 2.11 0 001.07-1.85v-2.5l-3.55-3.56a1.2 1.2 0 00-1.6-.08l-.1.08-1.37 1.37-.52-.61 1.33-1.32a2 2 0 012.72-.1l.1.1 2.99 2.98v-8.1c0-1.1-.82-2-1.85-2.09H26.83l-.71-.84zM33.45 34.2l-3.05 3.06-2.35-2.36a1.2 1.2 0 00-1.6-.08l-.1.08-3.46 3.47a2.01 2.01 0 001.91 1.48h13.44l-4.79-5.65zm-8.7-10.27a2.05 2.05 0 00-1.95 2.1v11.3l2.99-3a2 2 0 012.72-.09l.1.1 1.79 1.78 2.53-2.53-2.96-3.5a2.8 2.8 0 01-2.08 1.14h-.17a2.8 2.8 0 01-1.27-5.3zm2.23 2.64a2 2 0 102.46 2.9zm1.35-.87a2.8 2.8 0 012.2 2.73l-.01-.15z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMissingAppIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/missingAppIcon.2d6dd5b33ac22fff259e85ef15097004.svg";